'use client'

import { generateTagTrackingValue } from '@/components/common/product-card/helper'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import Link from 'next/link'
import { AmazonProductAddMobile } from './amazon-product-add-mobile'
import { AmazonProductItemHeader } from './amazon-product-item-header'
import { AmazonProductItemImages } from './amazon-product-item-images'
import { AmazonProductItemSizes } from './amazon-product-item-sizes'
import { useAmazonProductCardContext } from './context/amazon-product-card-context'

export const AmazonProductItemThumbnail = ({
  gaTrackingValue,
  gaTrackingLabel,
}: {
  gaTrackingValue?: string
  gaTrackingLabel?: string
}) => {
  const { product, trackingClickProduct } = useAmazonProductCardContext()

  // Auto-generate tracking value from product tags if not provided
  const finalTrackingValue =
    gaTrackingValue || generateTagTrackingValue(product.tags)

  const handleClick = () => {
    trackingClickProduct()
  }

  return (
    <div className='group relative'>
      <Link
        href={product.href}
        className='block h-full w-full'
        {...(finalTrackingValue
          ? {
              'ga-tracking-value': finalTrackingValue,
              ...(gaTrackingLabel && {
                'ga-tracking-label': gaTrackingLabel,
              }),
            }
          : {})}
        onClick={handleClick}
        aria-label={`View details for ${product.title}`}
      >
        <AmazonProductItemImages />

        {!product?.icon_thumbnail?.hide && product?.icon_thumbnail?.image && (
          <div className='absolute bottom-0 left-0 z-[1] h-auto w-full rounded-b-lg'>
            <Image
              src={ImageHelper.getImageUrl(
                product?.icon_thumbnail?.image,
                '585_663'
              )}
              width={433}
              height={62}
              alt={`${product.title} thumbnail image`}
              className='block h-auto w-full rounded-b-lg object-cover'
              loading='lazy'
            />
          </div>
        )}
        <AmazonProductItemHeader />
      </Link>
      <div className='max-lg:hidden'>
        <AmazonProductItemSizes />
      </div>
      <AmazonProductAddMobile
        className={
          !product?.icon_thumbnail?.hide && product?.icon_thumbnail?.image
            ? 'bottom-12'
            : 'bottom-6'
        }
      />
    </div>
  )
}
